import React from 'react'
import { getQ4LogoIcon } from '../../../../utils'

/**
 * Footer Component
 * @returns {*}
 * @constructor
 */
const Footer = () => {
  return (
    <footer className='page_footer'>
      <i className={`page_logo ${getQ4LogoIcon()}`} />
      <span>www.q4inc.com</span>
    </footer>
  )
}

export default Footer
